<template>
  <div class="vx-row match-height" id="creat-product">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('EditConfigurableProduct')" class="mt-2">
            <edit-tab></edit-tab>
          </vs-tab>
          <vs-tab
            :label="$t('ConfigurableProductOptionsManagement')"
            class="mt-2"
          >
            <options-management></options-management>
          </vs-tab>
          <vs-tab :label="$t('Gallery')" class="mt-2">
            <GalleryConfigurableProducts></GalleryConfigurableProducts>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import EditTab from "./EditTab.vue";
import OptionsManagement from "./OptionsManagement.vue";
import GalleryConfigurableProducts from "./partial/GalleryConfigurableProducts.vue";

export default {
  components: {
    EditTab,
    OptionsManagement,
    GalleryConfigurableProducts
  }
};
</script>
